import { client } from "./client";

export async function fetchProvider(zipcode: string, searchterm: string) {
  try {
    const response = await client.get("", {
      params: {
        methodName: "getProvider",
        zipcode,
        searchterm,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching provider data:", error);
    return null;
  }
}

export async function fetchProviderParams(params: {
  zipcode: string | null;
  searchterm: string;
  Planyear: string;
}) {
  try {
    const response = await client.get("", {
      params: {
        methodName: "getProvider",
        Planyear: params.Planyear,
        fromaddress: params.zipcode,
        withinmiles: 50,
        searchterm: `fullname:${params.searchterm}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching provider data:", error);
    return null;
  }
}

export async function fetchAllDoctorsNearby(params: {
  zipcode: string | null;
  miles: string;
  planyear: string;
}) {
  try {
    const response = await client.get("", {
      params: {
        methodName: "getProvider",
        Planyear: params.planyear,
        fromaddress: params.zipcode,
        withinmiles: params.miles,
        pageindex: 3,
        pagesize: 30,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching provider data:", error);
    return null;
  }
}
